
import propertyApiService from '../../../../services/api/property'
import { getBuildingInfo } from '@/api/building'

const state = {
  property: {},
  isPropertyActive: false
}

export const getters = {
  property: state => state.property,
  isPropertyActive: state => state.isPropertyActive
}

export const actions = {
  async fetchProperty ({ dispatch, commit, rootState }, { propertyId = '', buildingId = '' }) {
    const requests = [
      propertyApiService.fetchPropertyById(propertyId),
      propertyApiService.fetchPropertyBuildings(propertyId)
    ]
    const [property, propertyBuildingsData] = await Promise.all(requests)
    if (property == null || propertyBuildingsData == null) {
      console.log('Property not found.', property, propertyBuildingsData)
      dispatch('setBuildingNotFound', true)
    }
    const detailInfoRequests = (propertyBuildingsData.buildings || []).map(building => getBuildingInfo(building.objectId))
    const propertyBuildingsDetailData = await Promise.all(detailInfoRequests)
    property.buildings = propertyBuildingsData.buildings
      .filter(building => !building.unavailable)
      .sort((a, b) => a.index - b.index)
      .map(building => {
        const detailData = propertyBuildingsDetailData.find(data => data.objectId === building.objectId)
        if (detailData) {
          return Object.assign({}, building, detailData)
        }
        return building
      })

    const building = property.buildings.find(building => building.objectId === buildingId)
    property.meta = property.meta || {}
    commit('SET_PROPERTY', property)
    commit('SET_IS_PROPERTY_ACTIVE', true)
    // building id is in property 該群組有這個 buildingId，抓
    if (building) {
      dispatch('fetchBuilding', building.objectId)
    } else if (buildingId) {
      // building id is not found in property, but that's ok
      dispatch('fetchBuilding', buildingId)
    } else if (property.buildings.length) {
      // no building id, auto to first building 沒輸入，自動抓第一個
      dispatch('fetchBuilding', property.buildings[0].objectId)
    } else {
      // group 沒任何 building
      dispatch('setBuildingNotFound', true)
    }
    return property
  }
}

export const mutations = {
  SET_PROPERTY (state, property = {}) {
    state.property = property
  },
  SET_IS_PROPERTY_ACTIVE (state, isPropertyActive = false) {
    state.isPropertyActive = isPropertyActive
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
